import { z } from 'zod';
import { FlagJSONSchema } from './flag';

export const FeatureFlagsJSONSchema = z.object({
	result: z.array(FlagJSONSchema),
});

export type IFeatureFlagsJSON = z.infer<typeof FeatureFlagsJSONSchema>;
